import React, { useEffect, useState, useCallback } from "react";
import { FaEye, FaFilter } from "react-icons/fa6";
import { capitalizeWords } from "../../../../../utils/common";
import { Role } from "../../../../../constants/role";

import { DataTable } from "../../../../common";
import { IconMenuOption } from "../../../../controls";

const TopicList = ({
  topicList,
  showSelectionForTopics,
  memoizedHandleSelectedRowsOfTopic,
}) => {
  const columns = [
    {
      name: "Topic Name",
      selector: (row) => capitalizeWords(row?.label) || "-",
    },
  ];

  const customStyles = {
    cells: {
      style: {
        width: "100px",
      },
    },
  };

  return (
    <>
      <DataTable
        extraStylesForTable={"table-extras"}
        keyField={"_id"}
        columns={columns}
        data={topicList ? topicList : []}
        highlightOnHover={true}
        pointerOnHover={true}
        fixedHeader={true}
        //
        pagination={false}
        // paginationServer={true}
        // paginationPerPage={topicList?.limit}
        // paginationTotalRows={topicList?.totalDocs}
        // onChangeRowsPerPage={handleTableRowsChange}
        // onChangePage={handleChangePage}
        // currentPage={currentPage}
        //
        selectableRows={showSelectionForTopics}
        selectableRowsSingle={true}
        clearSelectedRows
        onSelectedRowsChange={memoizedHandleSelectedRowsOfTopic}
        //
        customStyles={customStyles}
      />
    </>
  );
};

export default TopicList;
